module.exports = __webpack_public_path__ + "static/media/in_point_charge.4b578bb7.svg";